import React from 'react'
import { Card } from '@etiquette-ui/misc';
import { useStaticQuery, graphql } from "gatsby";
import styled from 'styled-components';
import { device, minDevice } from '../../../../Theme';
import Img from 'gatsby-image';
import { TEXT } from '@etiquette-ui/colors';

const Container = styled(Card)`
    height: 128px;

    display: flex;
    align-items: center;

    flex: 0 0 32.5%;
    max-width: 32.5%;
    
    margin-bottom: 15px;
    padding-bottom: 17px;

    
    @media ${device.ipad} { 
        flex: 0 0 49%;
        max-width: 49%;
    }
    @media ${device.mobileXL} { 
        flex: 0 0 100%;
        max-width: 100%;
    }
`;
const Text = styled.div`
    color: ${TEXT};

    flex-grow: 1;
    flex-shrink: 1;
    margin-left: 15px;

    @media ${device.mobile} { 
        align-self: center;
    }

    h3, p {
        margin: 0;
    }
    h3 {
        font-size: 20px;
        @media ${minDevice.tablet} { 
            font-size: 24px;
        }
    }
`;
const Image = styled.div`

    max-width: 60px;
    flex: 0 0 60px;
    height: 60px;

    overflow: visible;

    @media ${minDevice.mobile} { 
        max-width: 80px;
        flex: 0 0 80px;
        height: 80px;
    }
`;
const CustomCard = ({ icon, title, description, className }) => {
    const data = useStaticQuery(Apps);
    const dataimage = data.allFile.edges;

    return (
        <Container className={`${className}`}>
            <Image>
                <Img
                    fluid={dataimage[icon].node.childrenImageSharp[0].fluid}
                    alt={dataimage[icon].node.base}
                    style={{
                        overflow: 'visible'
                    }}
                    imgStyle={{
                        width: '200%',
                        height: '200%',
                        position: 'absolute',
                        top: '-37%',
                        left: '-50%',
                    }}
                />
            </Image>
            <Text>
                <h3>{title}</h3>
                <p>{description}</p>
            </Text>
        </Container>
    )
}

export default CustomCard;

const Apps = graphql`
query cardContent {
    allFile(
      filter: {
        extension: {regex: "/(png)/"}, 
        name: {in: [
            "digitalmenu-icon",
            "managersite-icon",
            "reservations-icon",
            "surveycreator-icon",
            "dotell-icon",
            "dashboard-icon",
            "taskme-icon",
            "adminsite-icon",
            "appsinti-icon",
        ]}}
    ) {
      edges {
        node {
          base
          childrenImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;